import styled from 'styled-components';
import { Layout } from 'antd';
const LayoutSectionContent = styled(Layout) `
  height: calc(100vh - 64px);
  margin-top: 64px;
`;
export default LayoutSectionContent;
